module.exports = __webpack_public_path__ + "img/0Q3A3407_FoamcoreMatted.7552a161.jpg";